import React, { useState } from "react";
import verifyUserAuth from "../services/authTest";

const AuthTestComponent = () => {
    const [status, setStatus] = useState(null);

    const handleVerify = async () => {
        const result = await verifyUserAuth();
        setStatus(result);
    };

    return (
        <div>
            <h2>Test Authentication</h2>
            <button onClick={handleVerify}>Verify Authentication</button>
            {status && <pre>{JSON.stringify(status, null, 2)}</pre>}
        </div>
    );
};

export default AuthTestComponent;
